import React from 'react';
import * as PropTypes from 'prop-types';

const propTypes = {
  fallbackSrc: PropTypes.string.isRequired,
  src: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
};

const Image = props => {
  const { fallbackSrc, src, alt, ...restProps } = props;

  const addDefaultSrc = e => {
    e.target.src = fallbackSrc;
  };

  return <img {...restProps} onError={addDefaultSrc} src={src} alt={alt} />;
};

Image.propTypes = propTypes;

export default Image;
